import React from 'react'

export const IconDownCircle = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.25" stroke="white" strokeWidth="1.5"/>
    <path d="M4.92676 7.61523L8.73445 11.0768L12.5421 7.61523" stroke="white" strokeWidth="1.5"/>
    </svg>
  )
}

export const LogoPlaceHolder = () => {
  return (
    <div>
      <svg id="logo-38" width="78" height="32" viewBox="0 0 78 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M55.5 0H77.5L58.5 32H36.5L55.5 0Z" fill="#FF7A00"></path>
        <path d="M35.5 0H51.5L32.5 32H16.5L35.5 0Z" fill="#FF9736"></path>
        <path d="M19.5 0H31.5L12.5 32H0.5L19.5 0Z" fill="#FFBC7D"></path>
      </svg>
    </div>
  )
}

export const IconDown = () => {
  return (
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5.5 5.5L10 1" stroke="white"/>
    </svg>
  )
}

export const IconPlay = () => {
  return (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27 22V53L51.8 37.5L27 22Z" fill="white"/>
    <circle cx="37" cy="37" r="36.25" stroke="white" strokeWidth="1.5"/>
    </svg>
  )
}

export const IconStop = () => {
  return (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="calc(50% - 15px)" y="calc(50% - 15px)" width="30" height="30" fill="white"></rect>
      <circle cx="37" cy="37" r="36.25" stroke="white" strokeWidth="1.5"/>
    </svg>
  )
}

export const IconLogo = () => {
  return (
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 45" width="42" height="45">
    <defs>
      <image  width="41" height="45" id="img1" href="data:image/png;base64,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"/>
    </defs>
    <use id="Background" href="#img1" x="0" y="0"/>
  </svg>
  )
}